import React, { PureComponent } from 'react';
import { withRouter } from 'react-router';
import PropTypes from 'prop-types';
import {
  Container,
  Badge,
} from 'reactstrap';
import DataTable from '../../../shared/components/DataTable';
import LoadingSpinner from '../../../shared/components/LoadingSpinner';
import {
  filterMyHomework,
} from '../../../redux/actions/materiaPeriodoActions';
import { createErrorMessage } from '../../../helpers/notification';

class HomeworkContainer extends PureComponent {
  static propTypes = {
    history: PropTypes.shape({}).isRequired,
    materiaPeriodoId: PropTypes.string.isRequired,
    utilizaPorcentajePesoMateria: PropTypes.bool.isRequired,
  }

  constructor(props) {
    super(props);
    this.state = {
      page: 1,
      pageSize: 25,
      totalItemsCount: 0,
      loading: true,
      items: [],
      filters: { id: 10 },
    };

    this.columns = utilizaPorcentajePesoMateria => [
      {
        key: 'id',
        name: '#',
        width: '85px',
        format: ({ id, tareaMateriaId }) => `${id || tareaMateriaId}`,
      },
      {
        key: 'tarea', name: 'Tarea', width: '85px', search: false,
      },
      {
        key: 'tipoTarea',
        name: 'Tipo Tarea',
        width: '85px',
        className: 'text-center',
        format: row => `${row.tipoTarea.label}`,
      },
      {
        key: 'puntajeObtenido',
        name: 'Puntaje Obtenido',
        width: '85px',
        className: 'text-center',
        format: row => `${row.puntajeObtenido}`,
      },
      {
        key: 'puntajeTotal',
        name: 'Puntaje Total',
        width: '85px',
        className: 'text-center',
        format: row => `${row.puntajeTotal}`,
      },
      {
        key: 'porcentajePesoMateria',
        visible: utilizaPorcentajePesoMateria,
        name: 'Porcentaje Peso Materia',
        width: '85px',
        className: 'text-center',
      },
    ];
  }

  componentDidMount() {
    const { page, pageSize } = this.state;
    this.updateTable(page, pageSize);
  }

  updateTable = (page, pageSize, filters) => {
    this.setState({
      loading: true,
      page,
      pageSize,
      filters: filters || {},
    });
    const { materiaPeriodoId: subjectId } = this.props;
    filterMyHomework({
      subjectId,
      pageInfo: {
        page,
        pageSize,
        filters,
      },
      onSuccess: ({ items, totalItemsCount }) => {
        this.setState({
          loading: false,
          items,
          totalItemsCount,
        });
      },
      onError: () => {
        this.setState({ items: [], loading: false });
        createErrorMessage('Error al intentar cargar la lista de tareas');
      },
    });
  }

  onChangePage = (page) => {
    if (page) {
      const { pageSize, filters } = this.state;
      this.updateTable(page, pageSize, filters);
    }
  };

  onDataTableSubmit = (values) => {
    if (values) {
      const { pageSize } = this.state;
      this.updateTable(1, pageSize, values);
    }
  };

  onDataTableClearFilters = () => {
    const { pageSize } = this.state;
    this.updateTable(1, pageSize, {});
  };

  getGridActions = (key) => {
    const actions = {
      actions: this.actions,
    };
    return actions[key];
  }

  format = value => (
    <h4 key={`item_${value}`} style={{ display: 'flex' }}>
      <Badge
        key={`item_${value}`}
        color={!Number(value) ? 'secondary' : 'primary'}
      >
        {value}
      </Badge>
    </h4>
  );

  render() {
    const {
      loading,
    } = this.state;

    if (loading) {
      return <LoadingSpinner />;
    }

    const {
      utilizaPorcentajePesoMateria,
    } = this.props;

    const {
      items,
      page,
      pageSize,
      totalItemsCount,
      filters,
    } = this.state;

    return (
      <Container>
        <DataTable
          title="Listado de todas las tareas de clase"
          columns={this.columns(utilizaPorcentajePesoMateria)}
          items={items}
          onChangePage={this.onChangePage}
          page={page}
          pageSize={pageSize}
          totalItemsCount={totalItemsCount}
          getGridActions={key => this.getGridActions(key)}
          onSubmit={this.onDataTableSubmit}
          onClearFilters={this.onDataTableClearFilters}
          initialValues={filters}
          enableReinitialize
        />
      </Container>
    );
  }
}

export default withRouter(HomeworkContainer);
